<script lang="ts">
  import { ALL_DASHBOARD_ROLES, DASHBOARD_TITLES, resolveDashboardRole, type DashboardRole } from '../../lib/dashboard/resolve';
  import { dashboardPreview } from '../../lib/dashboard/preview.svelte';
  import { session } from '../../lib/auth.svelte';

  const BUILD = 'enterprise-2026-06-19';

  const selected = $derived(
    dashboardPreview.role ?? resolveDashboardRole(session.value?.roles),
  );

  function onChange(e: Event) {
    const v = (e.currentTarget as HTMLSelectElement).value as DashboardRole;
    dashboardPreview.role = v === 'admin' ? null : v;
  }
</script>

<div class="picker">
  <label class="picker-select">
    <span>Vista</span>
    <select value={selected} onchange={onChange} aria-label="Seleccionar dashboard por rol">
      {#each ALL_DASHBOARD_ROLES as r (r)}
        <option value={r}>{DASHBOARD_TITLES[r]}</option>
      {/each}
    </select>
  </label>
</div>

<style>
  .picker {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.85rem;
  }
  .picker-select { display: flex; flex-direction: column; gap: 0.15rem; }
  .picker-select span { font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase; }
  select {
    padding: 0.45rem 0.65rem;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    background: #fff;
    font: inherit;
    font-size: 0.88rem;
    font-weight: 600;
    color: #166534;
    min-width: 14rem;
  }
</style>
